import { BackgroundManagerNotOpenError } from '@aws-amplify/core';
import { ThemeOptions } from '@mui/material';

const defaultTheme: ThemeOptions = {
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1650, // all default except xl
    },
  },
  components: {
    MuiDivider: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderColor: theme.palette.divider,
        }),
      },
    },
    MuiChip: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: theme.shape.borderRadius,
        }),
      },
    },

    MuiTableCell: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderColor: theme.palette.primary.main,
          color: theme.palette.text.primary,
        }),
      },
    },

    MuiTab: {
      styleOverrides: {
        root: ({ theme }) => ({
          '&.Mui-selected': {
            fontWeight: 'bold',
          },
          '&:hover': {
            backgroundColor: theme.palette.secondary.light,
          },
        }),
      },
    },

    MuiTableRow: {
      styleOverrides: {
        root: ({ theme }) => ({
          '&:hover': {
            backgroundColor: theme.palette.secondary.light,
          },
        }),
      },
    },

    MuiList: {
      styleOverrides: {
        root: ({ theme }) => ({
          padding: '0',
          scrollbarWidth: 'thin',
          backgroundColor: theme.palette.background.default,
        }),
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: '0',
          backgroundColor: theme.palette.background.default,
          color: theme.palette.text.primary,
          '&:hover': {
            backgroundColor: theme.palette.secondary.light,
          },
        }),
      },
    },
    MuiListSubheader: {
      styleOverrides: {
        root: {
          background: 'unset',
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          color: theme.palette.text.primary,
          '&:hover': {
            backgroundColor: theme.palette.secondary.light,
          },
        }),
      },
    },

    MuiMenuItem: {
      styleOverrides: {
        root: ({ theme }) => ({
          '&:hover': {
            backgroundColor: theme.palette.secondary.light,
          },
          '&.Mui-selected:hover': {
            backgroundColor: theme.palette.secondary.light,
          },
        }),
      },
    },

    MuiNativeSelect: {
      styleOverrides: {
        root: ({ theme }) => ({
          '&:hover': {
            backgroundColor: theme.palette.secondary.light,
          },
        }),
      },
    },

    MuiIconButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          '&:hover': {
            backgroundColor: theme.palette.secondary.light,
          },
        }),
      },
    },

    MuiCircularProgress: {
      styleOverrides: {
        root: ({ theme }) => ({
          color: theme.palette.primary.main,
        }),
      },
    },

    MuiAccordion: {
      styleOverrides: {
        root: ({ theme }) => ({}),
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: ({ theme }) => ({
          backgroundColor: theme.palette.background.default,
          '&:hover': {
            backgroundColor: theme.palette.secondary.light,
          },
          '&.Mui-expanded': {
            backgroundColor: '#d6hj8o',
          },
        }),
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: ({ theme }) => ({
          backgroundColor: theme.palette.background.default,
        }),
      },
    },

    MuiButton: {
      styleOverrides: {
        root: ({ ownerState, theme }) => ({
          ...(ownerState.variant === 'contained' && {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.secondary.contrastText,
            '&:hover': {
              backgroundColor: theme.palette.secondary.light,
              color: theme.palette.primary.main,
            },
            borderRadius: '5px',
          }),
          ...(ownerState.variant === 'outlined' && {
            color: theme.palette.primary.main,
            borderColor: theme.palette.primary.main,
            '&:hover': {
              backgroundColor: theme.palette.secondary.light,
              color: theme.palette.primary.main,
            },
            borderRadius: '5px',
          }),
        }),
      },
    },
    MuiSwitch: {
      styleOverrides: {
        switchBase: {
          color: 'grey',
        },
        track: ({ theme }) => ({
          opacity: 0.4,
          backgroundColor: theme.palette.error.light,
          '.Mui-checked.Mui-checked + &': {
            opacity: 0.8,
            backgroundColor: theme.palette.success.main,
          },
        }),
      },
    },
  },

  typography: {
    button: {
      textTransform: 'none',
    },
    h1: {
      fontWeight: 'bold',
    },
    h2: {
      fontWeight: 'bold',
    },
    h3: {
      fontWeight: 'bold',
    },
    h4: {
      fontWeight: 'bold',
    },
    h5: {
      fontWeight: 'bold',
      fontSize: '22px',
    },
    h6: {
      fontWeight: 'bold',
    },
  },
};

export default defaultTheme;
